import { StyleSheet, View } from "react-native";

import { Logo, Typography } from "@smartrent/ui";

const Footer = () => {
  return (
    <View style={styles.root}>
      <Typography type="title5">Powered by</Typography>
      <View>
        <Logo width={112} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    alignItems: "center",
    backgroundColor: "#ffffff",
    bottom: 0,
    flexDirection: "row",
    justifyContent: "center",
    left: 0,
    position: "absolute",
    width: "100%",
    height: 32,
    zIndex: 2, // needs to be gte than AppShellBase's
  },
});

export default Footer;
